/**
 * The fields the user actually changed — nothing else goes to the server on an edit.
 *
 * 2026-10-11, SA-769715 / SA-800115. The record page sent the WHOLE record on save
 * (~190 fields), exactly as it was when the form opened. Schedule the activity from the
 * same page, then save the form a minute later, and the save wrote back the old Status
 * 'None', an empty technician and empty times — undoing the scheduling. The assignment
 * row survived, so the dispatch board kept showing the technician while the record said
 * "not scheduled". 14 activities ended that way in 2026, two of them still upcoming.
 *
 * Comparing against a baseline taken when editing STARTED (not against the record as it
 * is now) is the point: a change made meanwhile by someone else — or by this user from
 * another control — is not the user's edit and must not be sent back.
 */

function norm(v) {
  if (v === undefined || v === null) return '';
  if (typeof v === 'object') {
    try { return JSON.stringify(v); } catch { return String(v); }
  }
  return String(v);
}

/** { field: newValue } for every field whose value differs from `baseline`. */
export function changedFields(baseline, edited) {
  const before = baseline || {};
  const out = {};
  for (const [k, v] of Object.entries(edited || {})) {
    if (norm(v) !== norm(before[k])) out[k] = v;
  }
  return out;
}
